import React, { useState, useEffect } from 'react';
import { api } from '../../services/api';
import './Admin.css';

const formatPhp = (amount) => new Intl.NumberFormat('en-PH', {
  style: 'currency',
  currency: 'PHP',
  maximumFractionDigits: 0
}).format(Number(amount || 0));

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const [recentBookings, setRecentBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [statsRes, bookingsRes] = await Promise.all([
        api.get('/admin/stats'),
        api.get('/admin/bookings')
      ]);
      setStats(statsRes.data);
      setRecentBookings(bookingsRes.data.bookings.slice(0, 5));
    } catch (error) {
      console.error('データ取得エラー:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">読み込み中...</div>;
  }

  return (
    <div className="admin-dashboard">
      <div className="page-header">
        <h1>管理者ダッシュボード</h1>
        <p className="subtitle">システム全体の状況を確認できます</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">👨‍🎓</div>
          <div className="stat-content">
            <span className="stat-value">{stats?.totalStudents || 0}</span>
            <span className="stat-label">生徒数</span>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">👨‍🏫</div>
          <div className="stat-content">
            <span className="stat-value">{stats?.totalTeachers || 0}</span>
            <span className="stat-label">教師数</span>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">📅</div>
          <div className="stat-content">
            <span className="stat-value">{stats?.upcomingLessons || 0}</span>
            <span className="stat-label">予定レッスン</span>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">✅</div>
          <div className="stat-content">
            <span className="stat-value">{stats?.completedLessons || 0}</span>
            <span className="stat-label">完了レッスン</span>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">💴</div>
          <div className="stat-content">
            <span className="stat-value">{formatPhp(stats?.outstandingReceivables || 0)}</span>
            <span className="stat-label">未回収合計</span>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">🧾</div>
          <div className="stat-content">
            <span className="stat-value">{stats?.paidInvoices || 0}</span>
            <span className="stat-label">入金済み請求</span>
          </div>
        </div>
      </div>

      <div className="dashboard-section">
        <h2>最近の予約</h2>
        {recentBookings.length > 0 ? (
          <table className="admin-table">
            <thead>
              <tr>
                <th>日時</th>
                <th>生徒</th>
                <th>教師</th>
                <th>ステータス</th>
              </tr>
            </thead>
            <tbody>
              {recentBookings.map(booking => (
                <tr key={booking.id}>
                  <td>{new Date(booking.scheduled_at).toLocaleString('ja-JP')}</td>
                  <td>{booking.student_name}</td>
                  <td>{booking.teacher_name}</td>
                  <td>
                    <span className={`status-badge status-${booking.status}`}>
                      {booking.status === 'confirmed' ? '確定' :
                       booking.status === 'completed' ? '完了' :
                       booking.status === 'cancelled' ? 'キャンセル' : '保留'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="no-data">予約がありません</p>
        )}
      </div>

      <div className="quick-actions">
        <h2>クイックアクション</h2>
        <div className="action-buttons">
          <a href="/admin/users" className="action-btn">
            <span className="action-icon">👥</span>
            <span>ユーザー管理</span>
          </a>
          <a href="/admin/bookings" className="action-btn">
            <span className="action-icon">📅</span>
            <span>予約管理</span>
          </a>
          <a href="/admin/courses" className="action-btn">
            <span className="action-icon">📚</span>
            <span>コース管理</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
